import { FC } from 'react'

import GoBackButton from '@/components/shared/button/ui/GoBackButton'

type Props = {
  onBack: () => void
  hasRepeatParam?: boolean
}

const RequestFormTitle: FC<Props> = ({ hasRepeatParam, onBack }) => {
  return (
    <div className="flex items-center gap-24">
      {!hasRepeatParam && <GoBackButton onClick={onBack} />}
      <span>Обращения</span>
    </div>
  )
}

export { RequestFormTitle }
